import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import type {
	Icon,
	IconListColor,
} from '@valk-nx/components/ui-icon-list/src/lib/icon-list.interface';
import { cn } from '@valk-nx/core/lib/core';
import { SVG_ICON_IMPORTS } from '@valk-nx/helpers/lib/svg-unique-ids/svg-unique-ids.directive';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'vp-icon-list',
	templateUrl: './icon-list.component.html',
	imports: [SVG_ICON_IMPORTS, TranslatePipe],
})
export class IconListComponent {
	iconColor = input<IconListColor>('text-dark-primary');
	isHorizontal = input<boolean>(true);
	items = input.required<Icon[]>();
	protected readonly cn = cn;
}
